export { TonePlayout } from './TonePlayout';
export { ToneTrack } from './ToneTrack';
export { MidiToneTrack } from './MidiToneTrack';
export type { PlayableTrack, MidiClipInfo, MidiToneTrackOptions } from './MidiToneTrack';
export { SoundFontToneTrack } from './SoundFontToneTrack';
export type { SoundFontToneTrackOptions } from './SoundFontToneTrack';
export {
  SoundFontCache,
  timecentsToSeconds,
  getGeneratorValue,
  int16ToFloat32,
  calculatePlaybackRate,
  extractLoopAndEnvelope,
} from './SoundFontCache';
export type { SoundFontSample, PlaybackRateParams, LoopAndEnvelopeParams } from './SoundFontCache';
export type { TonePlayoutOptions, EffectsFunction } from './TonePlayout';
export type { ToneTrackOptions, TrackEffectsFunction } from './ToneTrack';

// Export global AudioContext manager
export {
  configureGlobalContext,
  getGlobalContext,
  getGlobalAudioContext,
  getGlobalToneContext,
  resumeGlobalAudioContext,
  getGlobalAudioContextState,
  closeGlobalAudioContext,
  isNativeGlobalContext,
  supportsNativeContextMode,
} from './audioContext';
export type { AudioContextOptions } from './audioContext';

// Export MediaStreamSource manager
export {
  getMediaStreamSource,
  releaseMediaStreamSource,
  hasMediaStreamSource,
} from './mediaStreamSourceManager';

// Export Tone.js-specific fade helper
export { getUnderlyingAudioParam } from './fades';

// Export Tone.js adapter for engine integration
export { createToneAdapter, isToneAdapter } from './TonePlayoutAdapter';
export type { ToneAdapterOptions, ToneAdapter, ToneEffectsTransport } from './TonePlayoutAdapter';
